import {useEffect,useState} from 'react'
//import {UserEditModalHeader} from './UserEditModalHeader'
//import {UserEditModalFormWrapper} from './UserEditModalFormWrapper'
import { ViewModalHeader } from './ViewModalHeader'
import axios from 'axios'
import { getFeatureId, getFeatureIdGlobal, getFeaturesDisponibles,getFeaturesDisponiblesGlobal } from '../request/request'
import Swal from 'sweetalert2'
import { useAuth } from '../../../auth'
import { useAppSelector } from '../../../../../redux/hooks'
import { useDebounce } from '../../../../../_metronic/helpers'
const API_URL = process.env.REACT_APP_API_URL


type Rol=
  {
  purchaseOrden:string
  ownerFullName:string
  id:string
  features:x[],
  startDate:string,
  endDate:string

  }
type x=
{
  id: string
  name:string
  Permissions:perm[]
}

type perm={
  id:number,
  name:string,
  description:string
}


const FeaturesUpdate = ( props:any ) => {
  /*********************************Constantes**************************************** */
  const tenant= useAppSelector(state =>state.TenantSlice.id)
  const Id = useAppSelector(state => state.SuscriptionSlice.id)


  const{currentUser}= useAuth()
  const[FeaturesDisp, setFeaturesDisp]=useState<x[]>([])
  const [selectedItems, setSelectedItems] = useState<number[]>([]);

  const [Features,setFeature]= useState<Rol>({
    purchaseOrden:'',
    ownerFullName:'',
    id:'',
    features:[],
    startDate:'',
    endDate: ''

   
  })


  // eslint-disable-next-line
  const [loading, setLoading] = useState(false)

  ////


  
  

  /************************************llamadas a la API ********************************************** */

  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  useEffect(() => {
    //colocar llamada al ep de ticket for id 
    const fetchData = async () => {
      try {
        if( props.id){
          if (currentUser?.ListPermiso?.includes('Tenant.list')){
            if(tenant===0){
              const UserResponse = await getFeatureId(props.id);
              setFeature(UserResponse.data);
              const featuresupdate= []

              for (const a of UserResponse.data.features){
                featuresupdate.push(a.id)
              }
              setSelectedItems(featuresupdate)
            }
            else if(tenant!==0){
              const UserResponse = await getFeatureIdGlobal(props.id,tenant);
              setFeature(UserResponse.data);

              const featuresupdate= []
              for (const a of UserResponse.data.features){

                featuresupdate.push(a.id)
              }
              setSelectedItems(featuresupdate)
            }
          }
      }
      } catch (error) {
        console.error('Error al obtener los permisos', error);
      }
       };
  
      fetchData();
  }, [props.id])


  useEffect(() => {
    //se llama al ep de permisos 
    const fetchData = async () => {
      try {
        if (currentUser?.ListPermiso?.includes('Tenant.list')){
        if(tenant===0){
          const permisos = await getFeaturesDisponibles();
          setFeaturesDisp(permisos.data)
        }
        else{
          const permisos = await getFeaturesDisponiblesGlobal();
          setFeaturesDisp(permisos.data)
        }
      }} catch (error) {
        console.error('Error al obtener las cuentas:', error);
      }
       };
  
      fetchData();
  }, [props.Tenant])


  


  /************************************************************************* */
  

    //const navigate = useNavigate();

    const handleSubmit =async (e:any) => {
    e.preventDefault();

    try{
      const featuresput= []
      for (const y of selectedItems){
        featuresput.push({id:y})
      }
      
      
      
      if(props.id !==null){
        const actualizar={
          Features: featuresput
        }
       if (tenant===0){ 
          await axios.put(API_URL+'/v1/suscription/updateFeature/'+props.id, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Feature has Update',
            showConfirmButton: false,
            timer: 1500
          })
          //window.location.reload();
        });
        }
        else{
          await axios.put(API_URL+'/v1/suscription/updateFeature/'+props.id+'?tenantId='+props.Tenant, actualizar)
          .then(res=>{ Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Your Feature has Update',
            showConfirmButton: false,
            timer: 1500
          })
          //window.location.reload();
        });
        }
      
      }
  }
    catch(error:any){
      console.log(error)

    }

    
   }

  

  ///////////////////////////////////////////////


  
  
  

    const handleCheckboxChange = (event:any) => {
        const { value, checked } = event.target;
        
        if (checked) {
            setSelectedItems((prevSelectedItems:Array<number>) => [...prevSelectedItems, Number(value)]);
        } else {
            setSelectedItems((prevSelectedItems:Array<number>) =>
                prevSelectedItems.filter((item) => item !== Number(value))
            );
        }
    };

   



   

  return (
    
    <>
    {props.id !==null &&
    <div>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'
      >
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            <ViewModalHeader setID={props.setID} />
            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
            <form className='form w-100' id='kt_login_signin_form' onSubmit={handleSubmit} >
                                {/* begin::Heading */}
                                {/*<Card4
                                icon='/media/svg/files/NubeTD.svg'
                                title=' '
    description=''></Card4>*/}
                                <div className='text-center mb-5'>
                                <h1 className='text-marino fw-bolder mb-3 f-titulo fs-md'>{Features.purchaseOrden}</h1>
                                <div className='text-gray-500 fw-semibold fs-6 f-parrafo'>Subscription period: <br />{Features.startDate} to {Features.endDate}</div>
                                </div>
                                {/* begin::Heading */}
                        
                                {/* begin::Login options */}

                                <div className='mb-2 bg-light-info p-8 rounded f-parrafo'>
                                    <div className='text-info'>
                                  
                                  Use this section to  <strong>Edit</strong> Features.
                                    </div>
                                </div>
                               
                                {/* Campos solicitud */}
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="name">Subscription Name </label>
                                   <input type="text" name='name' value={Features.purchaseOrden}className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   onChange={(e:any) => setFeature({...Features,purchaseOrden: e.target.value})}/>
                                </div>
                                <div>
                                   <label className='form-label fw-bolder text-dark fs-6 mb-0 f-parrafo' htmlFor="apellido">Owner</label>
                                   <input type="text" name='apellido' value={Features.ownerFullName}className='form-control form-control-solid border-gray-300 f-parrafo' 
                                   onChange={(e:any) => setFeature({...Features,ownerFullName: e.target.value})}/>
                                </div>
                              
                                <br />
                                <p className='form-label fw-bolder text-marino  text-center fs-3 mb-0 f-parrafo' >Features</p>
                                <br />
                                <div className="card-body card-scroll h-200px f-parrafo">
                                  {FeaturesDisp.length!==0&&FeaturesDisp.map((feat:any)=>(
                                    <>
                                    
                                  <label className='form-check form-check-custom form-check-solid align-items-start'>
                                    <input
                                      className='form-check-input me-3'
                                      type='checkbox'
                                      name='email-preferences[]'   
                                      value={feat.id}     
                                      onChange={handleCheckboxChange} 
                                      defaultChecked={selectedItems.includes(Number(feat.id))} 
                                      
                                    />

                                    <span className='form-check-label d-flex flex-column align-items-start'>
                                      <span className='fw-bolder text-dark fs-5 mb-0'>{feat.name} </span>
                                      <span className='text-muted fs-6'>
                                        {feat.Permissions.map((p:any,i:any)=>(
                                        <p key={i}><strong>{p.name}</strong>: {p.description}</p>
                                        ))}
                                      </span>
                                    </span>
                                  </label>
                                  <div className='separator separator-dashed my-6'></div>
                                  </>))}

                                      
                                      </div>

                                 {/* begin::Action */}
                                 <div className='d-grid mb-10 justify-content-center'>
                                  <div className='row'>
                                     <div className='col'>
                                        <button
                                          type='submit'
                                          id='kt_sign_in_submit'
                                          className='btn btn-primary'
                                  
                                          
                                        >
                                          {!loading && <span className='indicator-label'>Save</span>}
                                          {loading && (
                                            <span className='indicator-progress' style={{display: 'block'}}>
                                            Please wait...
                                              <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                            </span>
                                          )}
                                        </button>

                                     </div>
                                      <div className='col'>
                                        <button
                                         className='btn-cancel btn border border-pink text-pink f-parrafo'
                                         style={{width:'200px'}}
                                        onClick={() => props.setID(undefined)}

                                        >
                                          Cancel
                                        </button>
                                      </div>
                                  </div>
                          
                                </div>
                                {/* end::Action */}

                                
                            </form>
                            
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
      </div>
      }


      
      
    </>
  )
}
export {FeaturesUpdate}